import { render } from "./decorator.vue?vue&type=template&id=2d150624&scoped=true"
import script from "./decorator.vue?vue&type=script&lang=js"
export * from "./decorator.vue?vue&type=script&lang=js"

import "./decorator.vue?vue&type=style&index=0&id=2d150624&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d150624"]])

export default __exports__